import { useEffect, useState } from "react";
import { glyph, isCustom } from "../emoji";
import { useLantern, useSession } from "../hooks";

// Emoji draws an emoji by name: a built-in one as its glyph, a custom one
// as its image.
export function Emoji({ name }: { name: string }) {
  return isCustom(name) ? <CustomEmojiImage name={name} /> : <>{glyph(name)}</>;
}

function CustomEmojiImage({ name }: { name: string }) {
  const session = useSession();
  const { emoji } = useLantern();
  const [url, setURL] = useState<string | null>(null);
  const version = emoji.find((e) => e.name === name)?.created_at;
  useEffect(() => {
    let live = true;
    session.emojiURL(name)?.then((u) => live && setURL(u), () => {});
    return () => {
      live = false;
    };
  }, [name, version, session]);
  return url ? <img className="custom-emoji" src={url} alt={`:${name}:`} title={`:${name}:`} draggable={false} /> : <span className="custom-emoji" aria-label={`:${name}:`} />;
}
